import APIClient from '@/shared/http/clients/api'

const resourceName = 'api/v1/admin/config/modulos'
const APIAccess = process.env.APIBaseBPM

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIAccess}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIAccess}/${resourceName}/`, data, config)

const ModulesRepository = {
  GetAll,
  Update
}

export default ModulesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/modulos.js